import React from 'react';
import MatchStatisticsScrollable from '../../MatchStatisticsScrollable';
import { WidgetWrapper } from '../../../sportradar-widgets/WidgetWrapper';
import { SrWidgetMatchBasketballHeatmap } from '../../../sportradar-widgets/SrWidgetMatchBasketballHeatmap';

function BetradarMTStatisticsHeatMap({ matchId }) {
    return (
        <MatchStatisticsScrollable>
            <WidgetWrapper>
                <SrWidgetMatchBasketballHeatmap matchId={matchId} />
            </WidgetWrapper>
        </MatchStatisticsScrollable>
    );
}

export default BetradarMTStatisticsHeatMap;
